import {
  LOGIN_ACTION,
  LOGOUT_ACTION,
  SET_LOGIN_DETAILS,
  SET_PROFILE_IMAGE,
  IS_CHANGE_PASSWORD_SUCCESS,
} from "./Constants";

const INITIAL_STATE = {};

export default function loginReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOGIN_ACTION:
      return {
        ...state,
        ...{
          firstName: action.data.firstName,
          lastName: action.data.lastName,
          userName: action.data.username,
          authority: action.data.authorities[0].role,
          userId: action.data.userId,
          isSystemPassword: action.data.isSystemPassword,
        },
      };

    case SET_LOGIN_DETAILS:
      return {
        ...state,
        ...{
          firstName: action.data.firstName,
          lastName: action.data.lastName,
        },
      };

    case SET_PROFILE_IMAGE:
      return {
        ...state,
        ...{
          profilePicData: action.data,
        },
      };

    case IS_CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        ...{
          isChangePasswordSuccess: action.data,
        },
      };

    case LOGOUT_ACTION:
      return INITIAL_STATE;

    default:
      return state;
  }
}
